import React from 'react';
import '../../../public/scss/providerLink.scss';

export default function ProviderLink() {
    return (
     <div className="special-terms">
             {/*<div className="terms-group-1 col-6 d-flex align-items-stretch">*/}
                <div className="special-terms__container">
                    <strong className="special-terms__title">
                        <h4>Message to users:</h4>
                    </strong>
                    <ul className="special-terms__list">
                        <li className="list-item">
                        For plans offered within Indiana, to locate a medical provider within central Indiana, please visit 
                        <a href='https://member.valenzhealth.com/home' rel="noopener noreferrer" target="_blank" className="list-item__link"> https://member.valenzhealth.com/home. </a>
                        To locate a medical provider outside of central Indiana, please visit 
                        <a href='https://member.valenzhealth.com/home' rel="noopener noreferrer" target="_blank" className="list-item__link"> https://encoreconnect.com/encbgnrc/. </a>
                        </li>
                        <li className="list-item">
                        For all other networks, please use the directory below.
                        </li>
                    </ul>
                {/*</div>*/}
            </div> 
            {/*
            <div className="terms-group-2 col-6 d-flex align-items-stretch">
                
                <div className="special-terms__container">
                    <strong className="special-terms__title">
                        <h4>For plans issued in Indiana: </h4>
                    </strong>
                    <ul className="special-terms__list">
                        
                        <li className="list-item">
                            For providers in the central Indiana region, please visit
                            <a href="https://member.valenzhealth.com/home" rel="noopener noreferrer" target="_blank" className="list-item__link"> https://member.valenzhealth.com/home </a>
                            to locate a medical provider. Select ‘Valenz Access’ in the Plan Name drop down, after clicking the button below.
                        </li>
                        <li className="list-item">
                            To locate a medical provider outside of central Indiana, please visit
                            <a href="https://encoreconnect.com/encbgnrc/" rel="noopener noreferrer" target="_blank" className="list-item__link"> https://encoreconnect.com/encbgnrc/</a>
                        </li>
                        <li className="list-item">
                            For members who have access to the First Health Network, please visit
                            <a href="https://www.myfirsthealth.com/" rel="noopener noreferrer" target="_blank" className="list-item__link"> https://www.myfirsthealth.com/ </a>
                            to locate a medical provider.
                        </li>
                        <li className="list-item">
                            All other networks, please use the directory below.
                        </li>
                    </ul>
                </div>
            </div>*/}
            {/* <div className="terms-group-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                <div className="special-terms__container">
                    <strong className="special-terms__title">
                        <h4>For plans issued in Wisconsin: </h4>
                    </strong>
                    <ul className="special-terms__list">
                        <li className="list-item">

                            To locate a pediatric vision provider or a participating pharmacy, please use the directory below.
                        </li>
                    </ul>
                </div>
            </div> */}
        </div>
    );
}
